<script setup lang="ts">
/**
 * Pane Prose
 * --------------------------------
 * Pane with limited max width for better readability of long text content.
 */

const { center = false } = defineProps<{
    center?: boolean;
}>();
</script>

<template>
    <div
        class="w-full max-w-(--w-max-prose)"
        :class="{
            'md:mx-auto': center,
        }"
    >
        <slot />
    </div>
</template>
